import { TotemTicketsEntity } from "@/entities/TotemTicketsEntity.js";
import { apiRequest } from "@/services/api/apiClient.js";

const entity = new TotemTicketsEntity();
export async function getTotemTickets({ page = 1, limit = 10, ...filters } = {}) {
    return apiRequest({
        client: window.API_CHECKIN,
        method: "get",
        url: entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getTotemTicketById({id}) {
    return apiRequest({
        client: window.API_CHECKIN,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}

export async function createTotemTickets(data) {
    return apiRequest({
        client: window.API_CHECKIN,
        method: "post",
        url: entity.endpoints.create,
        body: data,
    });
}

export async function saveTotemTicket(data) {
    const isUpdate = !!data.id;
    let url = isUpdate
        ? entity.getUrl(entity.endpoints.get, { id: data.id })
        : entity.endpoints.create;

    const response = await apiRequest({
        client: window.API_CHECKIN,
        method: isUpdate ? "put" : "post",
        url,
        body: data,
    });

    return response;
}

export async function deleteTotemTickets({id}) {
    const url = entity.getUrl(entity.endpoints.delete, { id });
    return apiRequest({
        client: window.API_CHECKIN,
        method: "delete",
        url,
    });
}
